// Remember:
// Every file in scripts/ acts as an entry-point and gets tranformed to build/. Feel free to create as much as you want.
// Files in subdirectories will be ignored but you can require them in entry-point-files.
// Add an _ to a file and it will just be ignored(good for tests).
// Add your entry-point-files to templates/layout/yourlayout.html


// Example: Create a new directory for your component and require it in this entry-point-file like this...
// //=require mycomponent/mycomponent.js
// //=require ../modules/mycomponent/mycomponent.js

//=require ../../libraries/leaflet.js

//=require ../../patterns/organisms/map/mapConfigurationParser.js
//=require ../../patterns/organisms/map/tileLayerParser.js
//=require ../../patterns/organisms/map/poiConfigurationParser.js
//=require ../../patterns/organisms/map/popupMarkupCreator.js
//=require ../../patterns/organisms/map/map.js
